<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <M_heroLanding />
        <M_highLights :clientWidth="clientWidth"/>
        <M_Product />
        <div>market</div>
    </main>

</template>


<script>
    import M_heroLanding from "../../components/content/market/index/M_heroLanding";
    import M_Product from "../../components/content/market/index/M_Product";
    import M_highLights from "../../components/content/market/index/M_highLights";
    // import M_twoTout from "../../components/content/market/index/M_twoTout";


    export default {
        name: 'market',
        components: {
            M_heroLanding,
            M_highLights,
            // M_twoTout,
            M_Product
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {
            let that = this;
            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
